import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id", "disabled", "disableDeleteIcon", "error", "formattedToken", "formControlProps", "onClearInput", "readOnly", "requiredPermissionLevel"];
import styled from 'styled-components';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIIcon from 'UIComponents/icon/UIIcon';
import { SLINKY, GYPSUM, BATTLESHIP, ALERT_DANGER } from 'HubStyleTokens/colors';
import DataTokenMark from 'automation-ui-formula-editor/formula-editor/data-tag-mark/DataTokenMark';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSinglePropertyInputPropertyField = styled.div.withConfig({
  displayName: "SinglePropertyInputPropertyField__StyledSinglePropertyInputPropertyField",
  componentId: "sc-1759fg1-0"
})(["border-radius:3px;background:", ";padding:5px 30px 5px 10px;height:40px;display:flex;justify-content:space-between;align-items:center;", ""], GYPSUM, ({
  error
}) => {
  return error ? `border: 1px solid ${ALERT_DANGER};` : `border: 1px solid ${BATTLESHIP};`;
});
const SinglePropertyInputPropertyField = _ref => {
  let {
      'data-test-id': dataTestId,
      disabled,
      disableDeleteIcon,
      error,
      formattedToken,
      formControlProps,
      onClearInput,
      readOnly,
      requiredPermissionLevel
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const PropertyFieldJSX = /*#__PURE__*/_jsx(StyledSinglePropertyInputPropertyField
  // PM: Rest props are passed down to enable accessability props to
  // flow from any UIFormControls in consuming components
  , Object.assign({}, restProps, {
    "data-test-id": dataTestId,
    error: error,
    children: /*#__PURE__*/_jsx(UITruncateString, {
      tooltip: false,
      fixedChildren: !readOnly && !disabled && !disableDeleteIcon && /*#__PURE__*/_jsx(UIIconButton, {
        "data-test-id": "propertyDeleteBtn",
        use: "unstyled",
        placement: "right",
        onClick: onClearInput,
        className: "m-top-1",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.single-value-input.clear-tooltip"
        }),
        tooltipProps: {
          placement: 'top'
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "delete",
          color: SLINKY
        })
      }),
      children: /*#__PURE__*/_jsx(DataTokenMark, {
        formattedToken: formattedToken,
        clearable: !disableDeleteIcon && !readOnly && !disabled,
        onClearInput: onClearInput,
        use: "borderless",
        readOnly: readOnly,
        requiredPermissionLevel: requiredPermissionLevel
      })
    })
  }));
  return formControlProps ? /*#__PURE__*/_jsx(UIFormControl, Object.assign({}, formControlProps, {
    children: PropertyFieldJSX
  })) : PropertyFieldJSX;
};
export default SinglePropertyInputPropertyField;